// Shutterfly Gifting available only for these events
// In cstools, the feature switch is called 'shutterfly|'
// Added | to distinguish FE features and also for 'evite.feature' to work properly.
export const SHUTTERFLY_FEATURE_NAME = 'shutterfly';

const SHUTTERFLY_ENABLE_EVENT_TYPES = ['christmas', 'holiday_party'];
// TODO: this data should be obtained from cms
export const SHUTTERFLY_DATA = {
  feature_name: SHUTTERFLY_FEATURE_NAME,
  sponsor_name: 'shutterfly',
  supported_event_types: SHUTTERFLY_ENABLE_EVENT_TYPES,
  enable_message: 'Allow guests to send Shutterfly gifts for this event',
  logo_image: 'logo.jpg',
  banner_image: 'banner.jpg',
  banner_mobile_image: 'banner_mobile.jpg',
  products: [
    {
      title: 'Photo Book',
      image: 'photo_book.jpg',
      url: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-53`,
    },
    {
      title: 'Latte Mug',
      image: 'latte_mug.jpg',
      url: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-68`,
    },
    {
      title: 'Personalized Ornament',
      image: 'personalized_ornament.jpg',
      url: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-69`,
    },
    {
      title: 'Photo Blanket',
      image: 'fleece_blanket.jpg',
      url: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-70`,
    },
    {
      title: 'Personalized Glassware',
      image: 'personalized_glassware.jpg',
      url: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-71`,
    },
    {
      title: 'Ceramic Tile',
      image: 'ceramic_tile.jpg',
      url: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-72`,
    },
  ],
  seeMoreLink: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-73`,
  gifting_link_compact: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-73?mpt=${Date.now()}`,
  gifting_link: `https://adfarm.mediaplex.com/ad/ck/17638-246315-2124-73?mpt=${Date.now()}`,
};
